import {
  addCoordinates,
  subtractCoordinates,
  adjustTranslateCoordinate,
  calculateDistance,
  divideScope,
  getTranslateDelta,
  SCOPE_MIN,
  SCOPE_MAX,
} from '../../utils/utils.js'

export const handleGestureMove = (e, state) => {
  const {
    moveActivePointsRef,
    // 단일 터치
    clientCoord,
    previousMovePoint,
    translateAtPointerDown,
    // 멀티 터치
    getBoundingClientSgCanvas,
    downScopeRef,
    downDistanceRef,
    downCenterRef,
    downTranslateRef,
    scope,
    setScope,
    scaleRatio,
    scopeRef,
    setTranslate,
    selectedTool,
    // 동시편집
    triggerUpdateTranslateAndScope,
  } = state

  // ─── ** <단일 터치> ** -> 캔버스 이동 로직 (Move Tool 또는 마우스 휠 클릭) ─────────────────────────────
  if (moveActivePointsRef.current.length <= 1) {
    if (selectedTool === 'move' || e.buttons === 4) {
      let delta = subtractCoordinates(clientCoord, previousMovePoint.current)
      let tempTranslate = adjustTranslateCoordinate(
        addCoordinates(translateAtPointerDown.current, divideScope(delta, scope)),
        scope,
        scaleRatio.current
      )
      setTranslate(tempTranslate)

      // 동시편집
      requestAnimationFrame(() => {
        triggerUpdateTranslateAndScope(tempTranslate, scope)
      })
    }

    moveActivePointsRef.current[0].x = e.clientX
    moveActivePointsRef.current[0].y = e.clientY
  }

  // ─── 두 개 이상의 포인터가 감지된 경우 (멀티 터치) ─────────────────────────────
  if (moveActivePointsRef.current.length >= 2) {
    // 전처리
    // moveActivePointsRef : tool에 상관없이 동작하는 "제스처 기능"의 pointer 이벤트 저장한 변수
    for (let point = 0; point < moveActivePointsRef.current.length; point++) {
      if (e.pointerId === moveActivePointsRef.current[point].id) {
        moveActivePointsRef.current[point].x = e.clientX
        moveActivePointsRef.current[point].y = e.clientY
      }
    }

    let pointerMoveClientCord = []
    pointerMoveClientCord.push(
      subtractCoordinates(
        { x: moveActivePointsRef.current[0].x, y: moveActivePointsRef.current[0].y },
        getBoundingClientSgCanvas.current
      )
    )
    pointerMoveClientCord.push(
      subtractCoordinates(
        { x: moveActivePointsRef.current[1].x, y: moveActivePointsRef.current[1].y },
        getBoundingClientSgCanvas.current
      )
    )

    const currentCenter = {
      x: +((pointerMoveClientCord[0].x + pointerMoveClientCord[1].x) / 2).toFixed(2),
      y: +((pointerMoveClientCord[0].y + pointerMoveClientCord[1].y) / 2).toFixed(2),
    }
    const currentDistance = calculateDistance(pointerMoveClientCord[0], pointerMoveClientCord[1])

    // ─── ** <두 손가락 터치(멀티 터치)> ** -> 확대/축소 기능 (두 개의 포인터 입력 시 줌 제스처 실행) ─────────────────────────────
    if (moveActivePointsRef.current.length === 2) {
      // if (
      //   currentDistance / downDistanceRef.current > 0.95 &&
      //   currentDistance / downDistanceRef.current < 1.05
      // )
      //   return

      let nextScope = +((downScopeRef.current * currentDistance) / downDistanceRef.current).toFixed(
        6
      )
      nextScope =
        nextScope <= SCOPE_MIN * scaleRatio.current
          ? SCOPE_MIN * scaleRatio.current
          : nextScope >= SCOPE_MAX * scaleRatio.current
          ? SCOPE_MAX * scaleRatio.current
          : nextScope

      const translateDelta = getTranslateDelta(
        downCenterRef.current.x,
        downCenterRef.current.y,
        nextScope,
        downScopeRef.current
      )

      // let tempTranslate = adjustTranslateCoordinate(
      //   addCoordinates(
      //     addCoordinates(downTranslateRef.current, translateDelta),
      //     divideScope(
      //       {
      //         x: currentCenter.x - downCenterRef.current.x,
      //         y: currentCenter.y - downCenterRef.current.y,
      //       },
      //       nextScope
      //     )
      //   ),
      //   nextScope,
      //   scaleRatio.current
      // )
      // setTranslate(tempTranslate)

      let tempTranslate = adjustTranslateCoordinate(
        addCoordinates(downTranslateRef.current, translateDelta),
        nextScope,
        scaleRatio.current
      )
      setTranslate(tempTranslate)
      setScope(nextScope)
      scopeRef.current = nextScope

      // 동시편집
      requestAnimationFrame(() => {
        triggerUpdateTranslateAndScope(tempTranslate, nextScope)
      })
    }
    // ─── ** <세 손가락 이상 터치> ** →> 두 개의 포인터 입력 시 줌 제스처 실행 ─────────────────────────────
    else {
      let delta = subtractCoordinates(currentCenter, downCenterRef.current)
      let tempTranslate = adjustTranslateCoordinate(
        addCoordinates(downTranslateRef.current, divideScope(delta, scope)),
        scope,
        scaleRatio.current
      )
      setTranslate(tempTranslate)

      // 동시편집
      requestAnimationFrame(() => {
        triggerUpdateTranslateAndScope(tempTranslate, scope)
      })
    }

    return true
  }

  return false
}
